import { render, staticRenderFns } from "./RecreateWebsitePanel.vue?vue&type=template&id=38ec2e28&scoped=true&"
import script from "./RecreateWebsitePanel.vue?vue&type=script&lang=ts&"
export * from "./RecreateWebsitePanel.vue?vue&type=script&lang=ts&"
import style0 from "./RecreateWebsitePanel.vue?vue&type=style&index=0&id=38ec2e28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec2e28",
  null
  
)

export default component.exports